// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1801":"46736c2ab69cad24","4698":"8fa74eefdbb54697","8825":"87cf2f186eec3756"}[chunkId] + ".js";
};